import { Model, Attr, BelongsTo } from 'spraypaint'

import ApplicationRecord from '@/models/ApplicationRecord'
import Caretaker from '@/models/Caretaker'

@Model()
export default class SorewardsIssueTransaction extends ApplicationRecord {
  static jsonapiType = 'sorewards_issue_transactions'

  @Attr({ persist: false }) id!: string
  @Attr({ persist: false }) cardId!: string
  @Attr({ persist: false }) caretakerName!: string
  @Attr({ persist: false }) dotationOrder!: string
  @Attr({ persist: false }) beneficiary!: string
  @Attr({ persist: false }) issueDate!: string
  @Attr({ persist: false }) cardNumber!: string
  @Attr({ persist: false }) expiry!: string
  @Attr({ persist: false }) cardType!: string
  @Attr({ persist: false }) coverage!: number
  @Attr({ persist: false }) issuePrice!: number | null
  @Attr({ persist: false }) negotiated!: boolean

  @BelongsTo() caretaker!: Caretaker
}
